export default __webpack_public_path__ + "static/media/menu1.302b4fa8.png";